import React from 'react';

function AboutCoreTeamSection() {
  const styles = {
    section: {
      width: '100%',
      maxWidth: 1920,
      margin: '0 auto',
      padding: '64px clamp(24px, 12.5vw, 240px)',
      boxSizing: 'border-box',
      background: '#FFFFFF'
    },
    header: {
      textAlign: 'center',
      marginBottom: 48
    },
    headingBlock: {
      width: '100%',
      marginTop: 16
    },
    overline: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 20,
      lineHeight: '100%',
      letterSpacing: '-0.01em',
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    overlineWrap: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
      flexWrap: 'wrap'
    },
    overlineDash: {
      width: 60,
      height: 2,
      background: '#E73123',
      flexShrink: 0
    },
    titleRed: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 28,
      lineHeight: '100%',
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#E73123',
      margin: '16px 0 0 0'
    },
    titleBlack: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 28,
      lineHeight: '100%',
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#090909',
      margin: '4px 0 0 0'
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 48,
      flexWrap: 'wrap'
    },
    leftCol: {
      flex: '1 1 0',
      minWidth: 260,
      maxWidth: 560,
      textAlign: 'left'
    },
    roleLabel: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '100%',
      color: '#090909',
      margin: 0
    },
    roleRule: {
      display: 'inline-block',
      width: 48,
      height: 2,
      background: '#E73123',
      marginLeft: 12,
      verticalAlign: 'middle'
    },
    name: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 24,
      lineHeight: '100%',
      letterSpacing: 0,
      color: '#090909',
      margin: '12px 0 0 0'
    },
    body: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '28px',
      letterSpacing: 0,
      color: '#838383',
      margin: '20px 0 0 0'
    },
    bodyBold: {
      fontWeight: 700,
      color: '#090909'
    },
    rightCol: {
      flex: '0 0 420px',
      width: 420,
      maxWidth: '100%',
      minWidth: 0
    },
    image: {
      width: '100%',
      maxWidth: 420,
      display: 'block',
      opacity: 1
    }
  };

  return React.createElement('section', { style: styles.section },
    React.createElement('div', { style: styles.header },
      React.createElement('div', { style: styles.overlineWrap },
        React.createElement('span', { style: styles.overlineDash }),
        React.createElement('h2', { style: styles.overline }, 'OUR CORE TEAM'),
        React.createElement('span', { style: styles.overlineDash })
      ),
      React.createElement('div', { style: styles.headingBlock },
        React.createElement('h3', { style: { margin: 0, textAlign: 'center' } },
          React.createElement('span', { style: styles.titleRed }, 'LEADERSHIP '),
          React.createElement('span', { style: styles.titleBlack }, 'THAT BUILDS WITH')
        ),
        React.createElement('h3', { style: Object.assign({}, styles.titleBlack, { textAlign: 'center' }) }, 'VISION AND STRENGTH')
      )
    ),
    React.createElement('div', { style: styles.row },
      React.createElement('div', { style: styles.leftCol },
        React.createElement('p', { style: styles.roleLabel },
          'CEO',
          React.createElement('span', { style: styles.roleRule })
        ),
        React.createElement('h4', { style: styles.name },
          'MR. VIKRAM SINGH',
          React.createElement('br'),
          'RATHORE'
        ),
        React.createElement('p', { style: styles.body },
          'At ',
          React.createElement('span', { style: styles.bodyBold }, 'Sunrise Infrabuild Pvt Ltd, '),
          'we are driven by precision, integrity, and a commitment to excellence. Every project we undertake reflects our dedication to quality, safety, and innovation.'
        ),
        React.createElement('p', { style: styles.body },
          "As we contribute to India's growing infrastructure landscape, our focus remains on delivering strong, reliable foundations that stand the test of time. Together, we are building not just structures, but a stronger future."
        )
      ),
      React.createElement('div', { style: styles.rightCol, className: 'about-ceo-image-wrap' },
        React.createElement('img', {
          src: '/vikramrathore.png',
          alt: 'Mr. Vikram Singh Rathore - CEO',
          style: styles.image,
          className: 'about-ceo-image'
        })
      )
    )
  );
}

export default AboutCoreTeamSection;
